<template>
  <div class="cross_match_page">
    <div class="cross_match_content">
      <div class="cross_match_page_header">
        <div class="cross_match_page_title">{{ $t("crossMatch.pageTitle") }}</div>
      </div>
      <div class="cross_match_banner">
        <div class="cross_match_banner_text">
          <div class="cross_match_banner_title">{{ $t("crossMatch.bannerTitle") }}</div>
          <div class="cross_match_banner_subtitle">{{ $t("crossMatch.bannerSubtitle") }}</div>
          <div class="cross_match_banner_english">{{ $t("crossMatch.bannerEnglish") }}</div>
        </div>
        <div class="cross_match_banner_image" :style="bannerStyle"></div>
      </div>

      <div class="cross_match_grid">
        <div
          v-for="(card, index) in crossMatchCards"
          :key="card.key"
          class="cross_match_card"
          :class="{ 'cross_match_card_full': index === crossMatchCards.length - 1 }"
          @click="openPremiumPopup"
        >
          <div class="cross_match_card_index">{{ index + 1 }}</div>
          <div class="cross_match_card_icon">
            <svg v-if="card.icon === 'privateButler'" viewBox="0 0 64 64" focusable="false">
              <path d="M32 11c7.18 0 13 5.82 13 13 0 4.11-1.91 7.77-4.9 10.15 7.97 2.18 13.84 9.47 13.9 18.12v2.73H10v-2.73c.06-8.65 5.93-15.94 13.9-18.12A12.94 12.94 0 0 1 19 24c0-7.18 5.82-13 13-13Zm0 4a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 22c-8.87 0-16.21 6.6-17.41 15h34.82C48.21 43.6 40.87 37 32 37Zm14.5-18 5.5 6v12h-4v-10.45l-4.45-4.86 2.95-2.69Zm-29 0 2.95 2.69L16 26.55V37h-4V25l5.5-6Z" fill="currentColor" />
            </svg>
            <svg v-else-if="card.icon === 'invitationManagement'" viewBox="0 0 64 64" focusable="false">
              <path d="M10 17h44a4 4 0 0 1 4 4v22a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V21a4 4 0 0 1 4-4Zm0 4v1.12L32 36.38 54 22.12V21H10Zm44 6.06L33.53 40.9a3 3 0 0 1-3.06 0L10 27.06V43a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V27.06ZM22 11h20a5 5 0 0 1 5 5v4h-4v-4a1 1 0 0 0-1-1H22a1 1 0 0 0-1 1v4h-4v-4a5 5 0 0 1 5-5Z" fill="currentColor" />
            </svg>
            <svg v-else-if="card.icon === 'globalMatch'" viewBox="0 0 64 64" focusable="false">
              <path d="M27.5 9C16.18 9 7 18.18 7 29.5S16.18 50 27.5 50c4.11 0 7.93-1.21 11.13-3.29l9.86 9.86 2.83-2.83-9.74-9.74A20.4 20.4 0 0 0 48 29.5C48 18.18 38.82 9 27.5 9Zm0 4c2.3 0 4.48.5 6.45 1.4-.34.48-.88 1.2-1.45 1.73-.92.86-1.45 1.8-1.45 3.37 0 2.56 1.52 3.22 2.53 3.66.92.4 1.47.63 1.47 2.34 0 1.44-.79 2.64-2 3.6-1.7 1.35-2.55 2.7-2.55 4.9 0 1.03.16 1.95.43 2.79-.96.14-1.93.21-2.93.21-1.58 0-3.11-.18-4.58-.52.73-1.03 1.08-2.08 1.08-3.48 0-2.16-1.34-3.16-2.31-3.89-.96-.72-1.69-1.26-1.69-2.8 0-1.23.39-1.93 1.03-3.06.76-1.35 1.71-3.03 1.71-5.94 0-.92-.12-1.74-.32-2.49A16.43 16.43 0 0 1 27.5 13Zm0 33C18.39 46 11 38.61 11 29.5c0-4.96 2.2-9.41 5.67-12.43.06.35.09.72.09 1.13 0 1.87-.53 2.83-1.19 4.01-.72 1.28-1.55 2.72-1.55 4.99 0 3.6 2.06 5.14 3.42 6.16.8.59 1.58 1.16 1.58 2.68 0 1.12-.38 1.74-1.17 2.93A16.42 16.42 0 0 0 27.5 46Zm7.84-2.01c-.59-1.06-.84-2.18-.84-3.83 0-.84.18-1.47 1.03-2.14 2.3-1.82 3.52-4.4 3.52-6.73 0-4.2-2.24-5.17-3.89-5.88-.72-.31-1.11-.48-1.11-1.12 0-.38.04-.48.18-.61 1.08-1.01 2.05-2.33 2.59-3.18A16.45 16.45 0 0 1 44 29.5c0 6.26-3.5 11.7-8.66 14.49Z" fill="currentColor" />
              <path d="M44 45l9-9 2.83 2.83-9 9z" fill="currentColor" />
            </svg>
            <svg v-else-if="card.icon === 'hotelDiscount'" viewBox="0 0 64 64" focusable="false">
              <path d="M16 10h32a4 4 0 0 1 4 4v40H12V14a4 4 0 0 1 4-4Zm0 4v36h11V38h10v12h11V14H16Zm15 4h-6v6h6v-6Zm8 0h-6v6h6v-6Zm8 0h-6v6h6v-6Zm-16 10h-6v6h6v-6Zm8 0h-6v6h6v-6Zm8 0h-6v6h6v-6Z" fill="currentColor" />
            </svg>
            <svg v-else viewBox="0 0 64 64" focusable="false">
              <path d="M18 15h28a3 3 0 0 1 3 3v7h4a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V28a3 3 0 0 1 3-3h4v-7a3 3 0 0 1 3-3Zm1 10h26v-6H19v6Zm-7 4v18h40V29H12Zm17 4h6v2h-6v-2Z" fill="currentColor" />
            </svg>
          </div>
          <div class="cross_match_card_title">{{ $t(`crossMatch.cards.${card.key}.title`) }}</div>
          <div class="cross_match_card_desc">{{ $t(`crossMatch.cards.${card.key}.desc`) }}</div>
        </div>
      </div>

      <div class="cross_match_notice">
        <div class="cross_match_notice_icon">
          <svg viewBox="0 0 64 64" focusable="false">
            <path d="M44 25h-2v-5a10 10 0 1 0-20 0v5h-2a6 6 0 0 0-6 6v16a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V31a6 6 0 0 0-6-6Zm-18-5a6 6 0 0 1 12 0v5H26v-5Zm6 22a4 4 0 0 1-2-7.46V32h4v2.54A4 4 0 0 1 32 42Z" fill="currentColor" />
          </svg>
        </div>
        <div class="cross_match_notice_text">
          <div class="cross_match_notice_title">{{ $t("crossMatch.lockTitle") }}</div>
          <div class="cross_match_notice_desc">{{ $t("crossMatch.lockDesc") }}</div>
        </div>
      </div>

      <div
        v-if="showActivationPopup"
        class="activation_popup_mask"
        @click.self="closeActivationPopup"
      >
        <div class="activation_popup">
          <div class="activation_popup_icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false">
              <path d="M17 9h-1V7a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 1 1 4 0v2h-4V7Zm2 9.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z" fill="currentColor" />
            </svg>
          </div>
          <div class="activation_popup_title">
            {{ $t("crossMatch.premiumRequiredTitle") }}
          </div>
          <div class="activation_popup_message">
            {{ $t("crossMatch.premiumRequiredMessage") }}
          </div>
          <div class="activation_popup_actions">
            <button
              type="button"
              class="activation_popup_button"
              @click="closeActivationPopup"
            >
              {{ $t("setting.ok") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const {
  CROSS_MATCH_BANNER_IMAGE,
  CROSS_MATCH_CARD_KEYS,
} = require("./content");

export default {
  name: "CrossMatchPage",
  data() {
    return {
      showActivationPopup: false,
    };
  },
  computed: {
    crossMatchCards() {
      return CROSS_MATCH_CARD_KEYS.map((key) => ({
        key,
        icon: key,
      }));
    },
    bannerStyle() {
      return {
        backgroundImage: `url('${CROSS_MATCH_BANNER_IMAGE}')`,
      };
    },
  },
  methods: {
    openPremiumPopup() {
      this.showActivationPopup = true;
    },
    closeActivationPopup() {
      this.showActivationPopup = false;
    },
  },
};
</script>

<style lang="less" scoped>
.cross_match_page{
  min-height: 100vh;
  background: #1f1c1f;
  padding: 24px 16px 140px;
}

.cross_match_content{
  max-width: 760px;
  margin: 0 auto;
}

.cross_match_page_header{
  margin-bottom: 16px;
  text-align: center;
}

.cross_match_page_title{
  color: #f3c7a2;
  font-size: 34px;
  line-height: 1.2;
  font-weight: bold;
}

.cross_match_banner{
  min-height: 236px;
  border-radius: 24px;
  border: 1px solid rgba(230, 185, 138, 0.24);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
}

.cross_match_banner_image{
  width: 100%;
  min-height: 236px;
  background-color: #171412;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.cross_match_banner_text{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 56%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 22px 24px 24px;
  background: linear-gradient(90deg, rgba(18, 14, 12, 0.92) 0%, rgba(18, 14, 12, 0.78) 54%, rgba(18, 14, 12, 0.08) 100%);
}

.cross_match_banner_title{
  color: #f3c7a2;
  font-size: 38px;
  line-height: 1.2;
  font-weight: bold;
}

.cross_match_banner_subtitle{
  margin-top: 10px;
  color: rgba(243, 199, 162, 0.92);
  font-size: 24px;
  line-height: 1.4;
  font-weight: 600;
}

.cross_match_banner_english{
  margin-top: 12px;
  color: rgba(243, 199, 162, 0.68);
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: 1px;
}

.cross_match_grid{
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.cross_match_card{
  min-height: 220px;
  border-radius: 22px;
  border: 1px solid rgba(230, 185, 138, 0.2);
  background: linear-gradient(180deg, #232222 0%, #1a1a1a 100%);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
  padding: 22px 18px 24px;
  text-align: center;
  cursor: pointer;
}

.cross_match_card_full{
  grid-column: 1 / -1;
}

.cross_match_card_index{
  color: #f0c69d;
  font-size: 30px;
  font-weight: bold;
  text-align: left;
}

.cross_match_card_icon{
  width: 76px;
  height: 76px;
  margin: 16px auto 18px;
  color: #f0c69d;
}

.cross_match_card_icon svg{
  width: 100%;
  height: 100%;
  display: block;
}

.cross_match_card_title{
  color: #f0c69d;
  font-size: 32px;
  line-height: 1.35;
  font-weight: bold;
}

.cross_match_card_desc{
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 24px;
  line-height: 1.55;
}

.cross_match_notice{
  margin: 22px auto 0;
  max-width: 620px;
  border-radius: 24px;
  border: 1px solid rgba(230, 185, 138, 0.22);
  background: linear-gradient(180deg, #171717 0%, #0f0f0f 100%);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.24);
  padding: 22px 22px;
  display: flex;
  align-items: center;
  gap: 18px;
}

.cross_match_notice_icon{
  width: 66px;
  height: 66px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
}

.cross_match_notice_icon svg{
  width: 34px;
  height: 34px;
  display: block;
}

.cross_match_notice_text{
  min-width: 0;
}

.cross_match_notice_title,
.cross_match_notice_desc{
  color: rgba(255, 255, 255, 0.92);
  font-size: 28px;
  line-height: 1.55;
  font-weight: bold;
}

.cross_match_notice_desc{
  color: rgba(255, 255, 255, 0.9);
}

.activation_popup_mask{
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: rgba(8, 8, 8, 0.72);
  backdrop-filter: blur(8px);
}

.activation_popup{
  width: 100%;
  max-width: 560px;
  border-radius: 24px;
  padding: 36px 30px 30px;
  background: linear-gradient(180deg, #2a2528 0%, #171517 100%);
  border: 1px solid rgba(230, 185, 138, 0.38);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);
  text-align: center;
  position: relative;
}

.activation_popup::before{
  content: "";
  position: absolute;
  left: 24px;
  right: 24px;
  top: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(230, 185, 138, 0), rgba(230, 185, 138, 0.55), rgba(230, 185, 138, 0));
}

.activation_popup_icon{
  width: 92px;
  height: 92px;
  margin: 0 auto 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3c7a2;
  background: radial-gradient(circle at center, rgba(243, 199, 162, 0.18) 0%, rgba(243, 199, 162, 0.05) 65%, rgba(243, 199, 162, 0) 100%);
  box-shadow: inset 0 0 0 1px rgba(243, 199, 162, 0.18);
}

.activation_popup_icon svg{
  width: 46px;
  height: 46px;
  display: block;
}

.activation_popup_title{
  color: #f3c7a2;
  font-size: 34px;
  font-weight: bold;
  line-height: 1.2;
}

.activation_popup_message{
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 24px;
  line-height: 1.6;
}

.activation_popup_actions{
  margin-top: 30px;
}

.activation_popup_button{
  min-width: 180px;
  height: 74px;
  border: none;
  border-radius: 999px;
  padding: 0 36px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #3a2a1b;
  font-size: 26px;
  font-weight: bold;
  box-shadow: 0 10px 24px rgba(220, 171, 118, 0.28);
}
</style>
